import { RouteConfig } from 'vue-router'
import { ordersRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../../auth'

const Orders = () => import('@/pmd/pages/payments/v2/Orders.vue')
const OrderDetails = () => import('@/pmd/pages/payments/v2/OrderDetails.vue')

export const OrdersRoute: RouteConfig[] = [
  {
    path: 'payments/v2/orders',
    name: ordersRouteNames.orders,
    component: Orders,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/v2/orders/:orderId',
    name: ordersRouteNames.orderDetails,
    component: OrderDetails,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
